import React, { useState } from "react";
import "./ContactSection.css";

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    subject: "",
    message: ""
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false); // ✅ loading state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // start submitting

    try {
      const res = await fetch("https://api.vangalfarm.co.in/send-mail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      const data = await res.json();
      alert(data.msg);

      // Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        location: "",
        subject: "",
        message: ""
      });
    } catch (error) {
      alert("Failed to send message.");
      console.error(error);
    } finally {
      setIsSubmitting(false); // stop submitting
    }
  };

  return (
    <section className="vangal-contact-wrapper">
      <div className="vangal-contact-container">
        <h2 className="vangal-contact-title anim anim-top">
          Pure, Natural, Yours <br /> Exclusive at Vangal Farms
        </h2>

        <p className="vangal-contact-subtitle">
          Personalized Pricing, Special Offers – Made to Fit You.
        </p>

        <form className="vangal-contact-form anim anim-bottom" onSubmit={handleSubmit}>
          <input type="text" name="name" placeholder="Your Full Name *" className="vangal-contact-input" value={formData.name} onChange={handleChange} />
          <input type="email" name="email" placeholder="Your Email *" className="vangal-contact-input" value={formData.email} onChange={handleChange} />
          <input type="text" name="phone" placeholder="Your Phone No *" className="vangal-contact-input" value={formData.phone} onChange={handleChange} />
          <input type="text" name="location" placeholder="Your Location *" className="vangal-contact-input" value={formData.location} onChange={handleChange} />
          <input type="text" name="subject" placeholder="Subject *" className="vangal-contact-input" value={formData.subject} onChange={handleChange} />
          <textarea name="message" placeholder="Write your message *" className="vangal-contact-input" value={formData.message} onChange={handleChange} />

          <button className="vangal-contact-button" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit Now"} {/* ✅ button text changes */}
          </button>
        </form>
      </div>
    </section>
  );
}
